const AVATAR_PATHS: Record<LandingV2.PersonAvatarVariant, string> = {
  a: 'M12 3c-3 0-4.8 2-4.8 5 0 1 .1 1.9.4 2.7-.5.3-.8.9-.8 1.5 0 .8.5 1.5 1.2 1.7.5 1.4 1.5 2.5 2.6 3v1c0 .5-.3.9-.8 1.1l-3.4 1.3C5 20.9 4 22.3 4 24h16c0-1.7-1-3.1-2.4-3.7l-3.4-1.3c-.5-.2-.8-.6-.8-1.1v-1c1.1-.5 2.1-1.6 2.6-3 .7-.2 1.2-.9 1.2-1.7 0-.6-.3-1.2-.8-1.5.3-.8.4-1.7.4-2.7 0-3-1.8-5-4.8-5z',
  b: 'M12 6.6c-2.6 0-4.2 1.8-4.2 4.4 0 2.7 1.7 5 4.2 5s4.2-2.3 4.2-5c0-2.6-1.6-4.4-4.2-4.4zM8.9 17.2l-3.5 1.4C4 19.2 3 20.5 3 22.2V24h18v-1.8c0-1.7-1-3-2.4-3.6l-3.5-1.4c-.9.7-1.9 1.1-3.1 1.1s-2.2-.4-3.1-1.1z',
};

type Props = {
  variant: LandingV2.PersonAvatarVariant;
  size?: number;
  color: string;
};

export const PersonAvatarIcon = ({ variant, size = 40, color }: Props) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d={AVATAR_PATHS[variant]} />
  </svg>
);
